import { IEntityWithStatus, EntityWithStatus } from "./EntityWithStatus";
import { IEntityCustomFields } from "./EntityCustomFields";
import { IEntityContributors } from "./EntityContributors";
import { IEntityReportingCycle } from "./ReportingCycle";

export interface IReportingEntity extends IEntityWithStatus, IEntityCustomFields, IEntityContributors, IEntityReportingCycle {
    Description: string;
}

export class ReportingEntity extends EntityWithStatus implements IReportingEntity {
    public Description = '';
    public ReportingFrequency = null;
    public ReportingDueDay = null;
    // public ReportingStartDate = null;
    public CustomFields = [];
    public Contributors = [];
}

export interface IReportingEntityWithDeliveryDates extends IReportingEntity {
    BaselineDate: Date | null;
    ForecastDate: Date | null;
    ActualDate: Date | null;
}

export class ReportingEntityWithDeliveryDates extends ReportingEntity implements IReportingEntityWithDeliveryDates {
    public BaselineDate = null;
    public ForecastDate = null;
    public ActualDate = null;
}
